export default {
    namespaced: true,
    pbx_call: {
      title: "Ligação | Ligações",
      uuid: "UUID",
      status: "estado",
      caller: "chamador",
      receiver: "receptor",
      started_at: "começou a",
      ended_at: "terminou a",
      recording_url: "Gravação"
    },
  };
  